import React from "react";

import Box from '@mui/material/Box';
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LinearProgress from '@mui/material/LinearProgress';


export function ProgressBar({ displayTextInOneLine = false, text = null, percentage, minValueText, maxValueText, textColor, fontSize, donationEffectPercentage = 0, className }) {
    
    const textStyle = {
        color: textColor,
        fontSize: fontSize
    }
    return <Box sx={{ width: '100%' }} className={className}>
        <LinearProgress sx={{ margin: '10px 0 5px' }} variant="buffer" value={percentage > 100 ? 100 : percentage} valueBuffer={(percentage + donationEffectPercentage) || 0} />
            { 
            displayTextInOneLine ? <Typography sx={textStyle}>{text}</Typography>
            :
            minValueText && maxValueText ?
            <Stack flexDirection={'row'} justifyContent={'space-between'}>
                <Typography sx={textStyle}>{minValueText}</Typography>
                <Typography sx={textStyle}>{maxValueText}</Typography>
            </Stack>
            : null
        }

        
    </Box>
}